import React from 'react'
import { TextField } from '@material-ui/core'
import { appInputStyles } from './style'

const AppInput = (props) => {

  const classes = appInputStyles()

  let {
    name,
    label,
    type
  } = props

  return <>
    <TextField
      className={classes.TextBox}
      type={type}
      name={name}
      label={label} />
  </>
}

AppInput.defaultProps = {
  type: "text"
}

export default AppInput
